module.exports = __webpack_public_path__ + "img/pc_banner_sup_event.94940cd2.webp";